/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faBath } from '@fortawesome/free-solid-svg-icons/faBath'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function BathroomsField (props: FormNumberFieldProps) {
  const intl = useIntl()
  const { name = 'bathrooms', ...others } = props
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'bathrooms',
        defaultMessage: 'Salles de bains'
      })}
      name={name}
      parser={parseNumber}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faBath}
        />
      )}
      {...others}
    />
  )
}

export default BathroomsField
